import { HeaderNames } from '../constraints/headerNames';

export default async function getCSRFToken() {
  const res = await fetch('/api/csrf-token', {
    method: 'HEAD',
  });

  return res.headers.get(HeaderNames.XSRFToken);
};
